import { writable } from 'svelte/store';
import type { LocationAttrs, LocationAttrsArray } from './location.type';

const locationSchema: LocationAttrs = {
	id: '',
	created_at: undefined,
	systemname: '',
	placename: '',
	brandname: '',
	continent: '',
	website_url: '',
	image_url: '',
	description: '',
	project_type: [],
	twitter: '',
	insta: '',
	linkedin: '',
	// this is how we would bundle roles up into one column in the db and api
	// roles: [],
	projects: [],
	wallet: '',
	storyteller: '',
	communitybuilder: '',
	planner: '',
	promoter: '',
	treasurebuilder: '',
	engineer: '',
	medicinehuman: '',
	foodguru: '',
	repairspecialist: '',
	storyteller_avatar: '',
	communitybuilder_avatar: '',
	planner_avatar: '',
	promoter_avatar: '',
	treasurebuilder_avatar: '',
	engineer_avatar: '',
	medicinehuman_avatar: '',
	foodguru_avatar: '',
	repairspecialist_avatar: '',
	locationowner: '',
	published: false,
	impact_area: '',
	email: '',
	team_emails: '',
	applicant: '',
	applicant_social: '',
	stage: ''
};

export const locationStore = writable<LocationAttrs>(locationSchema);
export const locations = writable<LocationAttrsArray>([locationSchema]);
export const locationOwner = writable<boolean>(false);
export const projectAvatar = writable();
export const projectAvatarStr = writable<string>('');
// export const roleStore = writable<RoleAttrs>(rolesArray);
// this seems easier to handle with a separate store, similar to filter

export function setLocationId(id: string) {
	locationStore.update((current) => ({
		...current,
		id: id // Set the location ID
	}));
}
